import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, useMediaQuery } from '@mui/material';
import GeneralTile from './GeneralTile';
import MyBoards from './MyBoards';
import calendar_check from '../../icons/calendar-check.svg';
import books from '../../icons/books_transparent.svg';
import { getAdvisorQueryParams } from '../../utils/queryParams';
import calendar from '../../icons/calendar.svg';
import professional_goals from '../../icons/professional_goals.svg';
import { useAccount } from '../../contexts/Account';
import LeadershipFrame from '../../components/LeadershipFrame';
import InvitationsBoard from '../../components/Advisor/InvitationsBoard';
import ProfessionalGoals from './ProfessionalGoals';

function BoardsAndInvitations() {
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const { accountDetails, isFreeTrial, isFreemium } = useAccount();
  const [showDetails, setShowDetails] = useState(false);
  const [showLeadershipFrame, setShowLeadershipFrame] = useState(false);
  const [showProfessionalGoals, setShowProfessionalGoals] = useState(false);
  const [showAdvisoryBoards, setShowAdvisoryBoards] = useState(false);
  const [hideInvitationsTile, setHideInvitationsTile] = useState(false);
  const history = useHistory();

  const detailsRef = useRef(null);
  const mobileGoalsRef = useRef(null);
  const mobileBoardsRef = useRef(null);

  useEffect(() => {
    if (showDetails) {
      setTimeout(() => {
        if (isXS && showAdvisoryBoards) {
          mobileBoardsRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        } else if (isXS && showProfessionalGoals) {
          mobileGoalsRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        } else if (!isXS) {
          detailsRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        }
      }, 100);
    }
  }, [showDetails]);

  const sections = {
    advisoryBoards: setShowAdvisoryBoards,
    thoughtLeadership: setShowProfessionalGoals,
  };

  function toggleSection(sectionKey) {
    const isCurrentlyOpen =
      sectionKey === 'advisoryBoards'
        ? showAdvisoryBoards
        : showProfessionalGoals;

    Object.values(sections).forEach((setSection) => setSection(false));
    sections[sectionKey](!isCurrentlyOpen);
    setShowDetails(!isCurrentlyOpen);
  }

  return (
    <>
      <LeadershipFrame
        showLeadershipFrame={showLeadershipFrame}
        setShowLeadershipFrame={setShowLeadershipFrame}
      />
      <Box
        sx={{
          display: hideInvitationsTile ? 'none' : 'block',
        }}
      >
        <InvitationsBoard setHideComponent={setHideInvitationsTile} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: isXS ? 'column' : 'row',
          justifyContent: 'space-between',
          columnGap: '20px',
          rowGap: '20px',
        }}
      >
        <GeneralTile
          ids={{
            tileID: 'my-advisory-boards-tile-id',
            buttonID: 'my-advisory-boards-button-id',
          }}
          title="My Advisory Boards"
          onClick={() => toggleSection('advisoryBoards')}
          description="View your current advisory boards, share your ideas, make an introduction, attend board meetings and more."
          image={books}
        />
        {showDetails && showAdvisoryBoards && isXS ? (
          <Box ref={mobileBoardsRef} sx={{ scrollMarginTop: '130px' }}>
            <MyBoards />
          </Box>
        ) : null}
        <GeneralTile
          ids={{
            tileID: 'my-tools-tile-id',
            buttonID: 'my-tools-button-id',
          }}
          title="My Tools & Resources"
          onClick={() => history.push('/tools-resources')}
          description="Access resources to publish thought leadership, get exposure, and open the doors to a world of new opportunities through advisory work."
          image={calendar_check}
        />

        <GeneralTile
          ids={{
            tileID: 'my-professional-goals-tile-id',
            buttonID: 'my-professional-goals-button-id',
          }}
          title="My Professional Goals"
          onClick={() => toggleSection('thoughtLeadership')}
          description="Leverage advisory work to expose yourself to new types of professional opportunities and achieve your long-term professional goals."
          image={professional_goals}
          buttonText="View"
        />
        <GeneralTile
          ids={{
            tileID: 'start-your-own-advisory-board-tile-id',
            buttonID: 'start-your-own-advisory-board-button-id',
          }}
          title="Start Your Own Advisory Board"
          onClick={() => {
            window.location.assign(
              `https://register.advisorycloud.com/babs/add-your-advisory-board/?${getAdvisorQueryParams(
                {
                  accountDetails,
                  isFreeTrial,
                  isFreemium,
                }
              )}`
            );
          }}
          description="Included with your membership is the ability to start your own advisory board for your company, team or personal side project."
          image={calendar}
          buttonText="Get Started"
        />

        {showDetails && isXS ? (
          <Box ref={mobileGoalsRef} sx={{ scrollMarginTop: '130px' }}>
            {showProfessionalGoals && <ProfessionalGoals />}
          </Box>
        ) : null}
      </Box>

      {showDetails && !isXS && (
        <Box ref={detailsRef} sx={{ marginTop: '20px' }}>
          {showAdvisoryBoards && <MyBoards />}
          {!showAdvisoryBoards && showProfessionalGoals && (
            <ProfessionalGoals />
          )}
        </Box>
      )}
    </>
  );
}

export default BoardsAndInvitations;
